import { detect } from 'detect-browser'
import { useUserAgent } from '@/plugins/user-agent'

export function useIsMobileAgent(): { isMobileAgent: boolean } {
    const userAgent = useUserAgent()
    const browser = detect(userAgent)

    const isMobileAgent = (() => {
        switch (browser?.os) {
            case 'iOS':
            case 'Android OS':
            case 'BlackBerry OS':
            case 'Windows Mobile':
            case 'Amazon OS':
                return true
            default:
                return false
        }
    })()

    return { isMobileAgent }
}
